<div class="popup-warning">
    <div class="img-warning">
        <img src="assets/warning.png">
    </div>
    <div class="pop-up-custom">
        <div class="w-100 text-center">
            <!-- <h1 mat-dialog-title>You have {{data.trainings.length}} unfinished training.</h1> -->
            <div mat-dialog-content>
                <div>
                    <p class="text-normal">Anda belum melakukan pengkinian data Tenaga Pemasar. Silakan klik <a routerLink="/auth/agent-profile/data-update-form" (click)="closeDialog()">disini</a> untuk melakukan pengkinian.</p>
                </div>
            </div>
            <!-- <div mat-dialog-actions class="content-button">
                <div class="flex-col50">
                    <button mat-button class="col-50-btn btn-popup" (click)="closeDialog()">OK</button>
                </div>
            </div> -->
        </div>
    </div>
</div>
